//this hook is used in Set Aside, Other Land and Settlement
//if we have a landUseChange we need to display its values, if not we display the module values. All of these are disabled

import useLandUseTypeInput from "@pages/activityBuilder/modules/useLandUseTypeInput";
import { getLandUseOptions, getMainActivityLandUseOptions } from "@pages/activityBuilder/modules/landUseChanges/landUseChange";
import { useMemo } from "react";
import { useContextAwareGetLandUseChange } from "@hooks/index";
import { useAppSelector } from "@app/hooks";
import { FieldType, StartWithWithoutGeneric } from "@typedefs/modulesInterfaces";
import { BEModulesClassNames, FEModules } from "@utils/moduleList";
import { selectCurrentBuilder } from "@features/builder/builderSlice";
import { ModuleTypeRegistry } from "@utils/moduleTypeRegistry";

const useSpecialLandTypeInput = () => {
  const { moduleList } = useAppSelector(selectCurrentBuilder);
  const lucId = moduleList.find((module) => module.id === FEModules.LandUseChange)?.uniqueId;

  const { data: lucData, isLoading: isLoadingLuc } = useContextAwareGetLandUseChange(lucId ?? 0, { refetchOnMountOrArgChange: true, skip: !lucId });

  const setAsideInput = useLandUseTypeInput({
    inputName: "module.land_use_type",
    beModuleClassName: BEModulesClassNames.SetAside
  });
  const lucInput = useLucInput("luc.module_type");  
  const input = useMemo(() => lucData ? lucInput : setAsideInput, [lucData, setAsideInput, lucInput]);

  return { input, lucData, isLoadingLuc }
}

const useLucInput = (inputName: string) => {
  const moduleRegistry = ModuleTypeRegistry.getInstance();
  const otherLandModuleId = moduleRegistry.getIdByClassName(BEModulesClassNames.OtherLand) ?? 0

  const landUse: StartWithWithoutGeneric = {
    type: FieldType.SWW_SELECT,
    inputName: inputName,
    label: "module.type_of_land_use",
    startProps: { dropdownOptions: getLandUseOptions(), disabled: true },
    withProps: { dropdownOptions: [...getMainActivityLandUseOptions(), { id: otherLandModuleId, name: "Other land" }], disabled: true },
    withoutProps: { dropdownOptions: getLandUseOptions(), disabled: true },
  };

  return landUse
}

export default useSpecialLandTypeInput;